import * as React from 'react';

import { FormField } from 'components/form';
import Input from 'components/inputs/input/Input';

import { __t, applyTranslations } from 'utils/language';
import { isNotEmpty } from 'utils/validators';

import './delete-user-password.scss';

applyTranslations(require('./delete-user-password.i18n.json'));

interface Props {
  password: string,
  onChange: (password: string) => void
}

const MSG_KEY = 'delete_user_password';

const DeleteUserPassword: React.FC<Props> = ({
  password,
  onChange
}): JSX.Element => {
  const handlePasswordChange = (
    event: React.SyntheticEvent<HTMLInputElement>
  ): void => {
    const target = event.currentTarget;

    onChange(target.value);
  };

  return (
    <div className="delete-user-password">
      <FormField
        label={__t(`${MSG_KEY}.enter_password`)}
        labelType="highlighted"
        direction="column"
        showValidationIcon={false}
        showRequiredMark
        validators={[
          isNotEmpty(password, __t(`${MSG_KEY}.password_required`))
        ]}
      >
        <Input
          type="password"
          value={password}
          width="responsive"
          onChange={handlePasswordChange}
        />
      </FormField>
    </div>
  );
};

export default DeleteUserPassword;
